module.exports = __webpack_public_path__ + "media/bootstrap-icons/heptagon-99fe8565.svg";